import { HistoricRiskScoreRow } from 'app/modules/riskScore/queries/useGetHistoricRiskScores';

const isSameResult = (
  a: HistoricRiskScoreRow,
  b: HistoricRiskScoreRow,
): boolean =>
  a.risk_model_id === b.risk_model_id &&
  a.score === b.score &&
  a.source === b.source &&
  a.snapshot?.entity_segment_id === b.snapshot?.entity_segment_id;

// Keep only the oldest row of each run of identical runs — i.e. the moment the
// value changed to what it is. Rows must be newest-first (as the API returns
// them), so a row is a change point when the next (older) row is a different run.
export const filterUnchangedRiskScores = (
  rows: HistoricRiskScoreRow[],
): HistoricRiskScoreRow[] =>
  rows.filter((i, j) => {
    const older = rows[j + 1];
    return older === undefined || !isSameResult(i, older);
  });
